import * as React from 'react'
import Link from 'next/link'

interface IProps {
  id: string
  className?: string
  children: React.ReactNode
  onClick?(gid: string): void
}

export default function SeriesDetailLink(props: IProps) {
  const { id, children, className, onClick } = props
  return (
    <Link
      href={`/auto/images/detail?seriesId=${id}`}
      as={`/auto/series/${id}/images/`}
    >
      <a
        className={className}
        onClick={() => {
          onClick && onClick(id)
        }}
        target="_blank"
      >
        {children}
      </a>
    </Link>
  )
}
